"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const ConnectionSummary_1 = require("../ConnectionSummary");
const Field_1 = require("../Field");
const LogicalTable_1 = require("../LogicalTable");
const ServiceRegistry_1 = require("../Services/ServiceRegistry");
const TableSummary_1 = require("../TableSummary");
const ErrorHelpers_1 = require("../Utils/ErrorHelpers");
const FieldImpl_1 = require("./FieldImpl");
class DataSourceImpl {
    constructor(_dataSourceInfo, _registryId) {
        this._dataSourceInfo = _dataSourceInfo;
        this._registryId = _registryId;
        this._fields = _dataSourceInfo.fields.map((fieldModel) => {
            const fieldImpl = new FieldImpl_1.FieldImpl(fieldModel, this);
            return new Field_1.Field(fieldImpl);
        });
    }
    get name() {
        return this._dataSourceInfo.name;
    }
    get id() {
        return this._dataSourceInfo.id;
    }
    get extractUpdateTime() {
        return this._dataSourceInfo.extractUpdateTime;
    }
    get fields() {
        return this._fields;
    }
    get isExtract() {
        return this._dataSourceInfo.isExtract;
    }
    get isPublished() {
        return this._dataSourceInfo.isPublished;
    }
    publishedUrl() {
        return this._dataSourceInfo.publishedUrl;
    }
    getMaxPageRowLimit() {
        return 10000;
    }
    refreshAsync() {
        const dataSourceService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("data-source-service" /* DataSourceService */);
        return dataSourceService.refreshAsync(this._dataSourceInfo.id);
    }
    getConnectionSummariesAsync() {
        const dataSourceService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("data-source-service" /* DataSourceService */);
        return dataSourceService.getConnectionSummariesAsync(this._dataSourceInfo.id).then((summaries) => {
            return summaries.map((summary) => new ConnectionSummary_1.ConnectionSummary(summary));
        });
    }
    getActiveTablesAsync() {
        const dataSourceService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("data-source-service" /* DataSourceService */);
        return dataSourceService.getActiveTablesAsync(this._dataSourceInfo.id).then((tableInfos) => {
            return tableInfos.map((tableInfo) => new TableSummary_1.TableSummary(tableInfo));
        });
    }
    getUnderlyingDataAsync(options) {
        const getDataService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("get-data-service" /* GetData */);
        options = options || {};
        return getDataService.getDataSourceDataAsync(this.id, !!options.ignoreAliases, options.maxRows || 0, // 0 and [] are defaults
        options.columnsToInclude || [], options.columnsToIncludeById || [], options.includeDataValuesOption || api_external_contract_js_1.IncludeDataValuesOption.AllValues);
    }
    getLogicalTableDataAsync(logicalTableId, options) {
        const getDataService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("get-data-service" /* GetData */);
        options = options || {};
        return getDataService.getLogicalTableDataAsync(this.id, logicalTableId, !!options.ignoreAliases, options.maxRows || 0, // 0 and [] are defaults
        options.columnsToInclude || [], options.columnsToIncludeById || [], options.includeDataValuesOption || api_external_contract_js_1.IncludeDataValuesOption.AllValues);
    }
    getLogicalTableDataReaderAsync(logicalTableId, pageRowCount, options) {
        const getDataService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("get-data-service" /* GetData */);
        options = options || {};
        return getDataService.getLogicalTableDataReaderAsync(this.id, logicalTableId, pageRowCount || this.getMaxPageRowLimit(), !!options.ignoreAliases, options.columnsToIncludeById || [], options.includeDataValuesOption || api_external_contract_js_1.IncludeDataValuesOption.AllValues);
    }
    initializeWithPublicInterfaces(dataSource) {
        ErrorHelpers_1.ErrorHelpers.verifyInternalValue(dataSource, 'dataSource');
        this._fields = this._dataSourceInfo.fields.map((fieldModel) => {
            const fieldImpl = new FieldImpl_1.FieldImpl(fieldModel, dataSource);
            return new Field_1.Field(fieldImpl);
        });
    }
    getLogicalTablesAsync() {
        const dataSourceService = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("data-source-service" /* DataSourceService */);
        return dataSourceService.getLogicalTablesAsync(this.id).then((logicalTableInfos) => {
            return logicalTableInfos.map((logicalTableInfo) => new LogicalTable_1.LogicalTable(logicalTableInfo));
        });
    }
}
exports.DataSourceImpl = DataSourceImpl;
//# sourceMappingURL=DataSourceImpl.js.map